import React, { useState } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, CardImg, Badge, Tooltip } from "reactstrap";
import SkillChart from "../../charts/SkillChart";
import myImage from "../../assets/images/my-photo.jpg";

/**
 * Renders a <Tooltip /> component
 * @param {string} props.target – The target id for tooltip.
 * @param {string} props.children - The text to display in the tooltip.
 * @returns tooltip info in a badge.
 */
const TooltipHover = ({ target, children }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <Tooltip
      placement="top"
      isOpen={tooltipOpen}
      target={target}
      toggle={toggle}
      autohide={false}
    >
      {children}
    </Tooltip>
  );
};

TooltipHover.propTypes = {
  target: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
};

const About = () => {
  return (
    <Container fluid className="main-content me">
      <Row>
        <Col />
        <Col md="8" className="col__main">
          <Row>
            <Col md="12" lg="6">
              <h1 className="display-6">
                Hi, I&apos;m Thanapoom Phithakjarukorn.
              </h1>
              <p>
                I&apos;m a Front-End developer based in Las Vegas. I like to
                create graphics such as logos, business cards, posters,
                brochures, and websites. However, I consider myself as a new kid
                on the block in this field because there are many things that I
                don&apos;t fully understand. I am eager to learn new things.
              </p>
              <p>
                I&apos;ve done freelance work for small businesses, participated
                in startups, and collaborated with talented people to build
                digital products for both business and consumer use. I&apos;m
                naturally curious, relentlessly optimistic, and gradually &
                constantly improving my ability.
              </p>
              <div className="my-2">
                <Badge
                  href="https://developer.mozilla.org/en-US/docs/Web/HTML"
                  color="warning"
                  className="mx-1"
                  pill
                  id="hmtl"
                >
                  HTML
                </Badge>
                <TooltipHover target="hmtl">
                  HyperText Markup Language is the most basic building block of
                  the Web.
                </TooltipHover>
                <Badge
                  href="https://developer.mozilla.org/en-US/docs/Web/CSS"
                  color="warning"
                  className="mx-1"
                  pill
                  id="css"
                >
                  CSS
                </Badge>

                <TooltipHover target="css">
                  Cascading Style Sheets is used to describe the presentation of
                  a document written in HTML or XML and also how elements should
                  be rendered on screen, on paper, in speech, or on other media.
                </TooltipHover>
                <Badge
                  href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
                  color="warning"
                  className="mx-1"
                  pill
                  id="js"
                >
                  JavaScript
                </Badge>
                <TooltipHover target="js">JavaScript</TooltipHover>
                <Badge
                  href="https://reactjs.org"
                  color="warning"
                  className="mx-1"
                  pill
                  id="react"
                >
                  React
                </Badge>
                <TooltipHover target="react">React</TooltipHover>
                <Badge
                  href="https://getbootstrap.com/"
                  color="warning"
                  className="mx-1"
                  pill
                  id="bootstrap"
                >
                  Bootstrap
                </Badge>
                <TooltipHover target="bootstrap">Bootstrap</TooltipHover>
                <Badge
                  href="https://www.json.org/json-en.html"
                  color="warning"
                  className="mx-1"
                  pill
                  id="json"
                >
                  JSON
                </Badge>
                <TooltipHover target="json">JSON</TooltipHover>
                <Badge
                  href="https://firebase.google.com/docs"
                  color="warning"
                  className="mx-1"
                  pill
                  id="firebase"
                >
                  Firebase
                </Badge>
                <TooltipHover target="firebase">Firebase</TooltipHover>
                <Badge
                  href="https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Responsive_Design"
                  color="warning"
                  className="mx-1"
                  pill
                  id="responsive-design"
                >
                  RD
                </Badge>
                <TooltipHover target="responsive-design">
                  Responsive Design
                </TooltipHover>
                <Badge
                  href="https://xd.adobe.com/ideas/process/ui-design/ui-vs-ux-design-understanding-similarities-and-differences/"
                  color="warning"
                  className="mx-1"
                  pill
                  id="uiux"
                >
                  UI/UX
                </Badge>
                <TooltipHover target="uiux">UI/UX</TooltipHover>
                <Badge
                  href="https://www.atlassian.com/git/tutorials/what-is-git"
                  color="warning"
                  className="mx-1"
                  pill
                  id="git"
                >
                  Git
                </Badge>
                <TooltipHover target="git">Git</TooltipHover>
                <Badge
                  href="https://helpx.adobe.com/support/illustrator.html"
                  color="warning"
                  className="mx-1"
                  pill
                  id="illustrator"
                >
                  Illustrator
                </Badge>
                <TooltipHover target="illustrator">Illustrator</TooltipHover>
                <Badge
                  href="https://helpx.adobe.com/support/photoshop.html"
                  color="warning"
                  className="mx-1"
                  pill
                  id="photoshop"
                >
                  Photoshop
                </Badge>
                <TooltipHover target="photoshop">Photoshop</TooltipHover>
                <Badge
                  href="https://helpx.adobe.com/support/indesign.html"
                  color="warning"
                  className="mx-1"
                  pill
                  id="indesign"
                >
                  InDesign
                </Badge>
                <TooltipHover target="indesign">InDesign</TooltipHover>
              </div>
            </Col>
            <Col md="12" lg="6" className="d-flex flex-column">
              <Row>
                <CardImg className="my-image" src={myImage} alt="my-image" />
              </Row>
              <Row className="d-flex justify-content-center">
                <SkillChart />
              </Row>
            </Col>
          </Row>
        </Col>
        <Col />
      </Row>
    </Container>
  );
};

export default About;
